<div class="app-footer">
  <div class="app-footer__inner">
    <div class="app-footer-left">
      <span class="ps-2">Copyright {{ currentYear }} - Imtransporter.com</span>
    </div>
    <div class="app-footer-right">
      <a class="btn btn-sm btn-primary me-2" routerLink="">Homepage</a>
    </div>
  </div>
</div>
